module.exports = __webpack_public_path__ + "frontend/images/secure/sign-up-xs-7cbab8a2b8c89fa95c578c005d452a2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/secure/sign-up-xs.jpg
// module id = 332
// module chunks = 2